import { STUDY_ACTION_TYPES } from 'store/actions/study.actions';

const initialState = {
  sponsor: {},
  collaborator: {},
  processing: false,
};

export default function (state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case STUDY_ACTION_TYPES.STUDY_SET_DATA_BY_KEY:
      return { ...state, [payload.stateKeyForDataSaving]: { ...payload.data } };
    case STUDY_ACTION_TYPES.STUDY_SET_LINK_BY_KEY:
      return { ...state, [payload.stateKeyForLink]: payload.data };
    case STUDY_ACTION_TYPES.STUDY_CHANGE_PROCESSING:
      return {
        ...state,
        processing: payload,
      };
    case STUDY_ACTION_TYPES.STUDY_CLEAR_STATE:
      if (payload.shouldDeleteProperty) {
        const { [payload.clearedKey]: clearedKey, ...stateTail } = state;
        return { ...stateTail };
      } else {
        return { ...state, [payload.clearedKey]: {} };
      }
    default:
      return state;
  }
}
